/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class CircleButton extends Phaser.GameObjects.Container {
  constructor(scene, color,txt) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.color = color;
    this.txt = txt;
    this.bgSize = 84;

    this.bg = ABCyaPhaser.Graphics.addCircle(-this.bgSize, -this.bgSize, this.bgSize, this.color, this, { x: 0, y: 0 }, true, true);
    this.lbl = ABCyaPhaser.Text.addText(0, 0, 30, '0xFFFFFF', FontKeys._asapbold, this.txt, this, true).setWordWrapWidth(this.bgSize * 2 - 15);
  }
}